/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Fallback_LanguageInputs */



/**
* | output |
* | --- |
* | "Changelog not available in your language. Showing English." |
*
* @param {Whats_New_Fallback_LanguageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_fallback_language = /** @type {((inputs?: Whats_New_Fallback_LanguageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Fallback_LanguageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Changelog ist in Ihrer Sprache nicht verfügbar. Englisch wird angezeigt.")
	return /** @type {LocalizedString} */ ("Changelog not available in your language. Showing English.")
});